// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"678":"9b2b3cf5","725":"e6cb626c","787":"2344a55e"}[chunkId] + ".chunk.js";
};